import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'capitalize',
    standalone: false
})
export class CapitalizePipe implements PipeTransform {

    public transform(value: string): string {
        if (value) {
            return value[0].toUpperCase() + value.substring(1);
        }
        return value;
    }
}
